module.exports = __webpack_public_path__ + "static/media/frame_06.0326a57f.jpg";